import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Selection } from '../core/selection.js';
export var ReplaceCommand = /*#__PURE__*/function () {
  function ReplaceCommand(range, text) {
    var insertsAutoWhitespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, ReplaceCommand);

    this._range = range;
    this._text = text;
    this.insertsAutoWhitespace = insertsAutoWhitespace;
  }

  _createClass(ReplaceCommand, [{
    key: "getEditOperations",
    value: function getEditOperations(model, builder) {
      builder.addTrackedEditOperation(this._range, this._text);
    }
  }, {
    key: "computeCursorState",
    value: function computeCursorState(model, helper) {
      var inverseEditOperations = helper.getInverseEditOperations();
      var srcRange = inverseEditOperations[0].range;
      return new Selection(srcRange.endLineNumber, srcRange.endColumn, srcRange.endLineNumber, srcRange.endColumn);
    }
  }]);

  return ReplaceCommand;
}();
export var ReplaceCommandThatSelectsText = /*#__PURE__*/function () {
  function ReplaceCommandThatSelectsText(range, text) {
    _classCallCheck(this, ReplaceCommandThatSelectsText);

    this._range = range;
    this._text = text;
  }

  _createClass(ReplaceCommandThatSelectsText, [{
    key: "getEditOperations",
    value: function getEditOperations(model, builder) {
      builder.addTrackedEditOperation(this._range, this._text);
    }
  }, {
    key: "computeCursorState",
    value: function computeCursorState(model, helper) {
      var inverseEditOperations = helper.getInverseEditOperations();
      var srcRange = inverseEditOperations[0].range;
      return new Selection(srcRange.startLineNumber, srcRange.startColumn, srcRange.endLineNumber, srcRange.endColumn);
    }
  }]);

  return ReplaceCommandThatSelectsText;
}();
export var ReplaceCommandWithoutChangingPosition = /*#__PURE__*/function () {
  function ReplaceCommandWithoutChangingPosition(range, text) {
    var insertsAutoWhitespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, ReplaceCommandWithoutChangingPosition);

    this._range = range;
    this._text = text;
    this.insertsAutoWhitespace = insertsAutoWhitespace;
  }

  _createClass(ReplaceCommandWithoutChangingPosition, [{
    key: "getEditOperations",
    value: function getEditOperations(model, builder) {
      builder.addTrackedEditOperation(this._range, this._text);
    }
  }, {
    key: "computeCursorState",
    value: function computeCursorState(model, helper) {
      var inverseEditOperations = helper.getInverseEditOperations();
      var srcRange = inverseEditOperations[0].range;
      return new Selection(srcRange.startLineNumber, srcRange.startColumn, srcRange.startLineNumber, srcRange.startColumn);
    }
  }]);

  return ReplaceCommandWithoutChangingPosition;
}();
export var ReplaceCommandWithOffsetCursorState = /*#__PURE__*/function () {
  function ReplaceCommandWithOffsetCursorState(range, text, lineNumberDeltaOffset, columnDeltaOffset) {
    var insertsAutoWhitespace = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    _classCallCheck(this, ReplaceCommandWithOffsetCursorState);

    this._range = range;
    this._text = text;
    this._columnDeltaOffset = columnDeltaOffset;
    this._lineNumberDeltaOffset = lineNumberDeltaOffset;
    this.insertsAutoWhitespace = insertsAutoWhitespace;
  }

  _createClass(ReplaceCommandWithOffsetCursorState, [{
    key: "getEditOperations",
    value: function getEditOperations(model, builder) {
      builder.addTrackedEditOperation(this._range, this._text);
    }
  }, {
    key: "computeCursorState",
    value: function computeCursorState(model, helper) {
      var inverseEditOperations = helper.getInverseEditOperations();
      var srcRange = inverseEditOperations[0].range;
      return new Selection(srcRange.endLineNumber + this._lineNumberDeltaOffset, srcRange.endColumn + this._columnDeltaOffset, srcRange.endLineNumber + this._lineNumberDeltaOffset, srcRange.endColumn + this._columnDeltaOffset);
    }
  }]);

  return ReplaceCommandWithOffsetCursorState;
}();
export var ReplaceCommandThatPreservesSelection = /*#__PURE__*/function () {
  function ReplaceCommandThatPreservesSelection(editRange, text, initialSelection) {
    var forceMoveMarkers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, ReplaceCommandThatPreservesSelection);

    this._range = editRange;
    this._text = text;
    this._initialSelection = initialSelection;
    this._forceMoveMarkers = forceMoveMarkers;
    this._selectionId = null;
  }

  _createClass(ReplaceCommandThatPreservesSelection, [{
    key: "getEditOperations",
    value: function getEditOperations(model, builder) {
      builder.addTrackedEditOperation(this._range, this._text, this._forceMoveMarkers);
      this._selectionId = builder.trackSelection(this._initialSelection);
    }
  }, {
    key: "computeCursorState",
    value: function computeCursorState(model, helper) {
      return helper.getTrackedSelection(this._selectionId);
    }
  }]);

  return ReplaceCommandThatPreservesSelection;
}();